const Regions = {
  computed: {
    selectableRegions() {
      if (this.currentUserRole === 'region') {
        return this.currentUser.userRegions.map(r => {
          return {id: r.region.id, text: r.region.name}
        })
      }
      return this.basicRegions.map(r => {
        return {id: r.id, text: r.name}
      })
    }
  }
}

export default Regions
